import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Link } from "react-router-dom";

const MadeSimpleSection = () => {
    return (
        <>
            <section className="madeSimple_wrap section_pt section_pb">
                <div className="dashed_curve">
                    <div className="curve curve_1">
                        <svg className="Fe_H_Q"
                            style={{ stroke: 'rgb(48, 43, 43)', fill: 'rgb(48, 43, 43)', width: '233.408px', height: '72.4716px', }}>
                            <path
                                d="M3.753356183966929,69.16825000000063C79.05381909723965,-16.389416666666264 154.3542820105124,-16.389416666666264 229.65474492378522,69.16825000000063"
                                strokeLinecap="butt" strokeWidth="45.220722759902074" fill="none" pointerEvents="auto"
                                opacity="0" className="_682gpw" style={{ touchAction: 'pan-x pan-y pinch-zoom' }}></path>
                            <g>
                                <path
                                    d="M3.753356183966929,69.16825000000063C79.05381909723965,-16.389416666666264 154.3542820105124,-16.389416666666264 229.65474492378522,69.16825000000063"
                                    strokeDasharray="30,10" strokeLinecap="butt" strokeWidth="10" fill="none"
                                    pointerEvents="none"></path>
                            </g>
                        </svg>
                    </div>
                    <div className="curve curve_2">
                        <svg className="Fe_H_Q"
                            style={{ stroke: 'rgb(48, 43, 43)', fill: 'rgb(48, 43, 43)', width: '272.382px', height: '72.7626px' }}>
                            <path
                                d="M3.4757395253082564,69.16825000000017C91.95268160244042,-16.38941666666642 180.42962367957261,-16.38941666666642 268.9065657567048,69.16825000000017"
                                strokeLinecap="butt" strokeWidth="45.220722759902074" fill="none" pointerEvents="auto"
                                opacity="0" className="_682gpw" style={{ touchAction: 'pan-x pan-y pinch-zoom' }}></path>
                            <g>
                                <path
                                    d="M3.4757395253082564,69.16825000000017C91.95268160244042,-16.38941666666642 180.42962367957261,-16.38941666666642 268.9065657567048,69.16825000000017"
                                    strokeDasharray="30,10" strokeLinecap="butt" strokeWidth="10" fill="none"
                                    pointerEvents="none"></path>
                            </g>
                        </svg>
                    </div>
                    <div className="curve curve_3">
                        <svg className="Fe_H_Q"
                            style={{ stroke: 'rgb(48, 43, 43)', fill: 'rgb(48, 43, 43)', width: '280.765px', height: '83.2651px' }}>
                            <path
                                d="M3.913975469605475,79.66820000000052C83.05685617357577,-19.88939999999957 174.18279826220018,-19.88939999999957 277.29180173547866,79.66820000000052"
                                strokeLinecap="butt" strokeWidth="45.220722759902074" fill="none" pointerEvents="auto"
                                opacity="0" className="_682gpw" style={{ touchAction: 'pan-x pan-y pinch-zoom' }}></path>
                            <g>
                                <path
                                    d="M3.913975469605475,79.66820000000052C83.05685617357577,-19.88939999999957 174.18279826220018,-19.88939999999957 277.29180173547866,79.66820000000052"
                                    strokeDasharray="30,10" strokeLinecap="butt" strokeWidth="10" fill="none"
                                    pointerEvents="none"></path>
                            </g>
                        </svg>
                    </div>
                    <div className="curve curve_4">
                        <svg className="Fe_H_Q"
                            style={{ stroke: 'rgb(48, 43, 43)', fill: 'rgb(48, 43, 43)', width: '239.627px', height: '64.4942px' }}>
                            <path
                                d="M2.904541721773967,60.42439999999988C106.45212682183342,-13.47479999999996 183.9926278702529,-13.47479999999996 235.5260448670324,60.42439999999988"
                                strokeLinecap="butt" strokeWidth="64" fill="none" pointerEvents="auto" opacity="0"
                                className="_682gpw" style={{ touchAction: 'pan-x pan-y pinch-zoom' }}></path>
                            <g>
                                <path
                                    d="M2.904541721773967,60.42439999999988C106.45212682183342,-13.47479999999996 183.9926278702529,-13.47479999999996 235.5260448670324,60.42439999999988"
                                    strokeDasharray="30,10" strokeLinecap="butt" strokeWidth="10" fill="none"
                                    pointerEvents="none"></path>
                            </g>
                        </svg>
                    </div>
                </div>
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="titles">
                                <h2 className="wow fadeInLeft">Booking Made Simple<br />
                                    With <b>Orbi</b></h2>
                            </div>
                        </div>
                    </div>
                    <div className="row g-5 position-relative d-md-flex d-none">
                        <div className="dashed_curveMobile d-md-none">
                            <div className="curve curve_1">
                                <svg className="Fe_H_Q"
                                    style={{ stroke: 'rgb(48, 43, 43)', fill: 'rgb(48, 43, 43)', width: '233.408px', height: '72.4716px' }}>
                                    <path
                                        d="M3.753356183966929,69.16825000000063C79.05381909723965,-16.389416666666264 154.3542820105124,-16.389416666666264 229.65474492378522,69.16825000000063"
                                        strokeLinecap="butt" strokeWidth="45.220722759902074" fill="none"
                                        pointerEvents="auto" opacity="0" className="_682gpw"
                                        style={{ touchAction: 'pan-x pan-y pinch-zoom' }}></path>
                                    <g>
                                        <path
                                            d="M3.753356183966929,69.16825000000063C79.05381909723965,-16.389416666666264 154.3542820105124,-16.389416666666264 229.65474492378522,69.16825000000063"
                                            strokeDasharray="30,10" strokeLinecap="butt" strokeWidth="10" fill="none"
                                            pointerEvents="none"></path>
                                    </g>
                                </svg>
                            </div>
                            <div className="curve curve_2">
                                <svg className="Fe_H_Q"
                                    style={{ stroke: 'rgb(48, 43, 43)', fill: 'rgb(48, 43, 43)', width: '239.627px', height: '64.4942px' }}>
                                    <path
                                        d="M2.904541721773967,60.42439999999988C106.45212682183342,-13.47479999999996 183.9926278702529,-13.47479999999996 235.5260448670324,60.42439999999988"
                                        strokeLinecap="butt" strokeWidth="64" fill="none" pointerEvents="auto" opacity="0"
                                        className="_682gpw" style={{ touchAction: 'pan-x pan-y pinch-zoom' }}></path>
                                    <g>
                                        <path
                                            d="M2.904541721773967,60.42439999999988C106.45212682183342,-13.47479999999996 183.9926278702529,-13.47479999999996 235.5260448670324,60.42439999999988"
                                            strokeDasharray="30,10" strokeLinecap="butt" strokeWidth="10" fill="none"
                                            pointerEvents="none"></path>
                                    </g>
                                </svg>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-12">
                            <div className="step_col wow fadeInLeft">
                                <span>STEP 1</span>
                                <h3>Choose Destination & Date</h3>
                                <p>Enter your pickup and drop-off details along with the date and time of travel.</p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-12">
                            <div className="step_col wow fadeInUp">
                                <span>STEP 2</span>
                                <h3>Select Your Vehicle</h3>
                                <p>Pick the ride that fits your need and comfort level.</p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-12">
                            <div className="step_col wow fadeInRight">
                                <span>STEP 3</span>
                                <h3>Confirm Your Booking</h3>
                                <p>Enter your pickup and drop-off details along with the date and time of travel.</p>
                            </div>
                        </div>
                        <div className="col-lg-12 col-md-12 col-12 d-md-block d-none">
                            <div className="orbiStore_links">
                                <Link to="#"
                                    onClick={(e) => e.preventDefault()} className="wow fadeInLeft" data-bs-toggle="modal"
                                    data-bs-target="#playStoreModal"><img src="assets/img/all-images/and-small.webp"
                                        alt="Google Play small badge" /><span>Download in Playstore</span></Link>
                                <Link to="#"
                                    onClick={(e) => e.preventDefault()} className="wow fadeInRight" data-bs-toggle="modal"
                                    data-bs-target="#appStoreModal"><img src="assets/img/all-images/ios-small.webp"
                                        alt="Apple App Store small badge" /><span>Download in Appstore</span></Link>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="d-md-none d-block">
                    <div className="container">

                        <Swiper
                            modules={[Navigation, Autoplay, Pagination]}
                            slidesPerView={1}
                            spaceBetween={20}
                            loop={true} 
                            navigation={true}
                            pagination={{ clickable: true }}
                            autoplay={{
                                delay: 2000, 
                                disableOnInteraction: false, 
                            }}
                            speed={800} // smooth animation
                        >

                            <SwiperSlide>
                                <div className="step_col text-center">
                                    <span>STEP 1</span>
                                    <h3>Choose Destination & Date</h3>
                                    <p>
                                        Enter your pickup and drop-off details along with the date
                                        and time of travel.
                                    </p>
                                </div>
                            </SwiperSlide>

                            <SwiperSlide>
                                <div className="step_col text-center">
                                    <span>STEP 2</span>
                                    <h3>Select Your Vehicle</h3>
                                    <p>
                                        Pick the ride that fits your need and comfort level.
                                    </p>
                                </div>
                            </SwiperSlide>

                            <SwiperSlide>
                                <div className="step_col text-center">
                                    <span>STEP 3</span>
                                    <h3>Confirm Your Booking</h3>
                                    <p>
                                        Enter your pickup and drop-off details along with the date
                                        and time of travel.
                                    </p>
                                </div>
                            </SwiperSlide>

                        </Swiper>

                    </div>
                </div>
            </section>
        </>
    );
};

export default MadeSimpleSection;